// The rules of the Lumen Combobox (combobox.tsx), kept as the Mantine Select had them.

export interface ComboboxOption {
  value: string;
  label: string;
}

/** Mantine Select's filter: the label contains the trimmed search, ignoring case. A blank search matches all. */
export function optionMatches(label: string, search: string): boolean {
  return label.toLowerCase().includes(search.toLowerCase().trim());
}

/** The options a search shows, in their order. A blank search returns `options` itself. */
export function filterOptions<T extends ComboboxOption>(options: T[], search: string): T[] {
  return search.trim() ? options.filter((option) => optionMatches(option.label, search)) : options;
}

/** cmdk's `filter` for the `button` look: 1 keeps an item, 0 hides it. Its only keyword is the label. */
export const cmdkFilter = (_value: string, search: string, keywords?: string[]) =>
  optionMatches((keywords ?? []).join(' '), search) ? 1 : 0;

/**
 * Mantine's `allowDeselect`: picking the selected option again clears the value. With `allowDeselect` false a
 * re-pick hands the same value back (`ui/combobox` without `clearable`).
 */
export function pickValue(current: string | null, picked: string, allowDeselect = true): string | null {
  return allowDeselect && picked === current ? null : picked;
}
